const namespace = "regulations";

export const PARTICIPATION_ID = `${namespace}.participationId`;
